document.addEventListener("DOMContentLoaded", function () {
  /* --slide-- */
  document.querySelectorAll('.sustainability__slider').forEach((sliderWrap) => {
    const swiperElement = sliderWrap.querySelector('.swiper'); 
    const paginationElement = sliderWrap.querySelector('.swiper-pagination'); 
    const nextButton = sliderWrap.querySelector('.swiper-button-next'); 
    const prevButton = sliderWrap.querySelector('.swiper-button-prev'); 

    new Swiper(swiperElement, {
      loop: true,
      autoplay: {
        delay: 8000,
      },
      speed: 800,
      pagination: {
        el: paginationElement,
        clickable: true,
      },
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
    });
  });

  /* --movie-- */
  document.querySelectorAll(".section-movie__cover").forEach(function (cover) {
    cover.addEventListener("click", function () {
      cover.style.transition = "opacity 0.9s ease-out";
      cover.style.opacity = "0";

      setTimeout(function () {
        cover.style.display = "none";
      }, 900);

      const nextElement = cover.nextElementSibling;
      if (nextElement) {
        videoControl(nextElement, "playVideo");
      }
    });
  });

  function videoControl(target, action) {
    const playerWindow = target.contentWindow;
    playerWindow.postMessage(
      JSON.stringify({ event: "command", func: action, args: "" }),
      "*"
    );
  }

  /* --fade in-- */
  function handleScroll() {
    document.querySelectorAll(".fadein").forEach(function (element) {
      const rect = element.getBoundingClientRect();
      const o = rect.top;

      if (o < window.innerHeight && !element.classList.contains("on")) {
        element.classList.add("on");
      } else if (o > window.innerHeight && element.classList.contains("on")) {
        element.classList.remove("on");
      }
    });
  }

  handleScroll();

  window.addEventListener("load", handleScroll);
  window.addEventListener("scroll", handleScroll);
});

